export default __webpack_public_path__ + "static/media/avatarAnonimo.a07c4565.png";